import { render, staticRenderFns } from "./ChartNote.vue?vue&type=template&id=55c64b61"
import script from "./ChartNote.vue?vue&type=script&lang=js"
export * from "./ChartNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports